// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1Umlb","label":"Category_label__Inavf","content":"Category_content__ZMGAz","header":"Category_header__24iks","location":"Category_location__169PV"};